import React from 'react';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';

import { Container, Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphNumbers = ({ id, entity }) => {
  const entityJS = entity.toJS();
  const amount = entityJS.field_number.length;

  const { t } = useTranslation();

  return (
    <Container id={id} className="Paragraph">
      <div className="Numbers">
        <div className="Numbers__wrapper row">
          <div className="Numbers__anchor" id={t('entities.numbers').toLowerCase()} />
          <div className="col-12 col-lg-12">
            {entityJS.field_title[0] && (
              <h2 className="Numbers__title">{entityJS.field_title[0].value}</h2>
            )}
          </div>
          {entityJS.field_number.map((numberEntity, index) => {
            const number = numberEntity.entity;
            const iconSource = number.field_svg_icon[0]?.entity.field_media_svg[0].source;
            return (
              <div className={`col-12 ${amount === 3 && 'col-lg-4'} ${amount === 2 && 'col-lg-6'}`}>
                <div className="Numbers__card">
                  {iconSource && (
                    <Image className="Numbers__icon" src={iconSource} />
                  )}
                  {(number.field_number[0] && !number.field_float[0]) && (
                    <CountUp
                      className="Numbers__number"
                      duration={4}
                      easingFn={(t, b, c, d) => {
                        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                      }}
                      end={number.field_number[0].value}
                      separator="."
                      prefix={number.field_prefix[0] ? number.field_prefix[0].value + ' ' : ''}
                      suffix={number.field_suffix[0] ? ' ' + number.field_suffix[0].value : ''}
                      enableScrollSpy
                      scrollSpyOnce
                    />
                  )}
                  {(!number.field_number[0] && number.field_float[0]) && (
                    <span className="Numbers__number">
                      {number.field_prefix[0] && <span>{number.field_prefix[0].value}&nbsp;</span>}
                      {parseFloat(number.field_float[0].value).toLocaleString('nl-NL')}
                      {number.field_suffix[0] && <span>&nbsp;{number.field_suffix[0].value}</span>}
                    </span>
                  )}
                  <p className="Numbers__label">
                    {number.field_label[0] ? number.field_label[0].value : <span>&nbsp;</span>}
                  </p>
                  {number.body[0] && (
                    <WysiwygField
                      className="Numbers__body"
                      property="schema:text"
                      html={number.body[0].processed}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphNumbers;
